import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DefaultcaseService } from "../defaultcase/shared/defaultcase.service";
import { LoanService } from "../../loan/shared/loan.service";
import { Savings } from "../../savings/shared/savings.model";
import { SavingsService } from "../../savings/shared/savings.service";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-defaultcase',
  templateUrl: './defaultcase.component.html',
  styleUrls: ['./defaultcase.component.css']
})
export class DefaultcaseComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  SavingsId: number;
  readonlyDisabled: boolean = false;
  readonlyTextBox: boolean = true;
  Address: string;
  Name: string;
  savings: Savings;

  constructor(private loanService: LoanService,
    private savingsService: SavingsService,
    public defaultcaseService: DefaultcaseService,
    private router: Router, private route: ActivatedRoute,
    public datePipe: DatePipe) {

  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.SavingsId = +  params['Id'];
    });

    this.resetForm();

    if (Number.isNaN(this.SavingsId)) {
      this.defaultcaseService.selectedDefaultCase.Id = 0;
      this.defaultcaseService.selectedDefaultCase.Flag = 2; // updating 
      this.defaultcaseService.selectedDefaultCase.IsActive = true;
      this.readonlyDisabled = false;
      this.AddButtonText = "Save";
    }
    else {
      this.readonlyDisabled = true;
      this.defaultcaseService.selectedDefaultCase.SavingsId = + this.SavingsId;
      this.defaultcaseService.selectedDefaultCase.Flag = 2;
      this.defaultcaseService.selectedDefaultCase.IsActive = true;
      this.AddButtonText = "Edit & Save";
      this.getDefaultCaseById();
    }

  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.defaultcaseService.selectedDefaultCase = {
      Id: 0,
      SavingsId: 0,
      DefaultCaseDate: new Date().toString(),
      IsDefaultCase: false,
      IsDefaultDemandStop: false,

      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: null,
      Flag: 0,
      ToDate: null,
    }
  }

  onSubmit(form: NgForm) {

    if (this.defaultcaseService.selectedDefaultCase.SavingsId != null) {
      this.defaultcaseService.IUDDefaultChange(form.value)
        .toPromise()
        .then(data => {
          this.router.navigate(['/defaultcaselist']);
        })
    }
    else {

    }
  }

  public ClickSearch(event: any) {

    // this.getLoanDeatils(this.defaultcaseService.selectedDefaultCase.SavingsId)
    this.getSavingsDeatils(this.defaultcaseService.selectedDefaultCase.SavingsId);
  }

  getSavingsDeatils(SavingsId: any) {

    this.savings = new Savings();
    this.savings.Id = SavingsId;
    this.savings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.savingsService.FetchSavingsById(this.savings)
      .toPromise()
      .then(data => {
        // console.log(data);        
        this.Address = data.Address;
        this.Name = data.CustomerName;
      })
      .catch(err => { console.log(err) });
  }

  getDefaultCaseById() {
    this.defaultcaseService.FetchDefaultCaseById(this.defaultcaseService.selectedDefaultCase)
      .toPromise()
      .then(data => {
        
        // this.defaultcaseService.selectedDefaultCase.Id = data.Id ;
        this.defaultcaseService.selectedDefaultCase.SavingsId = data.SavingsId;
        this.SavingsId = data.SavingsId;
        // this.defaultcaseService.selectedDefaultCase.DefaultCaseDate = data.DefaultCaseDate;
        this.defaultcaseService.selectedDefaultCase.DefaultCaseDate = this.datePipe.transform(data.DefaultCaseDate, 'MM/dd/yyyy')
        this.defaultcaseService.selectedDefaultCase.IsDefaultDemandStop = data.IsDefaultDemandStop;
        this.Address = data.CustomerAddress;
        this.Name = data.CustomerName;
        this.defaultcaseService.selectedDefaultCase.Flag = 2;
      })
  }

}
